import styled from "styled-components"
import padding from "@irati/ui/src/global/padding"
import {greys} from "@irati/ui/src/global/colors"

const LimitInfo = styled.div`
  width: 100%;
  padding: ${padding.tiny};
  border-radius: 3px;
  background-color: ${greys.lightest};
  margin-bottom: 10px;
`

export default LimitInfo
